var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72992 21H21.2599C22.0299 21 22.5099 20.17 22.1299 19.5L12.8599 3.5C12.4699 2.83 11.5099 2.83 11.1299 3.5L1.85992 19.5C1.47992 20.17 1.95992 21 2.72992 21V21ZM12.9999 18H10.9999V16H12.9999V18ZM11.9999 14C11.4499 14 10.9999 13.55 10.9999 13V11C10.9999 10.45 11.4499 10 11.9999 10C12.5499 10 12.9999 10.45 12.9999 11V13C12.9999 13.55 12.5499 14 11.9999 14Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.909ab3f04a453fea7fcd5be276b1ae84.svg";
export { ForwardRef as ReactComponent };